var _defs, _mask, _use, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPersonWithCircle = function SvgPersonWithCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M23.458 1.629c12.956 0 23.458 10.502 23.458 23.458 0 12.956-10.502 23.459-23.458 23.459C10.502 48.546 0 38.043 0 25.087S10.502 1.63 23.458 1.63z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: "150.6%",
    height: "150.6%",
    x: "-25.3%",
    y: "-21.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 1.877,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.121568627 0 0 0 0 0.145098039 0 0 0 0 0.156862745 0 0 0 0.35 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M0 .205h134.78v181.274H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M.25.252h28.63v27.184H.25z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(8 4)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#b)",
    xlinkHref: "#a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeWidth: 1.877,
    d: "M23.458.69c13.474 0 24.397 10.923 24.397 24.397 0 13.474-10.923 24.397-24.397 24.397C9.984 49.484-.938 38.56-.938 25.087-.938 11.613 9.984.691 23.458.691z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#614CD4",
    d: "M48.667 51.643s55.076 56.38 37.424 72.591c-17.651 16.212-48.218-8.693-53.857-25.375-5.639-16.682 16.433-47.216 16.433-47.216"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-52.13 37.441)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A399FF",
    d: "M21.422 177.117c-41.327-28.712-10.474-117.209-8.608-139.87C14.272 19.555 27.473 4.99 44.98 2.054c27.41-4.599 49.148-2.47 68.775 28.115 6.957 10.84-10.598 17.634-15.507 38.398-2.47 10.454 4.685 58.069 30.218 64.612 35.645 9.136-90.513 63.95-107.044 43.938",
    mask: "url(#e)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#614CD4",
    d: "M76.336 170.62c-25.532-6.543-32.688-54.158-30.217-64.612C51.027 85.245 68.582 78.45 61.626 67.61 49.988 49.474 37.608 41.345 23.743 38.69c2.261 5.51 4.244 12.053 3.884 17.507-.788 11.963-16.13 30.453-11.395 49.811 4.734 19.358.522 32.626 11.438 46.982 7.164 9.422 24.898 28.214 36.242 40.017 16.887-9.64 25.428-19.053 12.424-22.386"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5C298",
    d: "M16.528 23.782L6.913 41.095C6.39 43.771 19.426 53.88 24.286 51.277c1.424-.763 1.555-3.394.907-6.393l-4.12-16.44-4.545-4.662z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#311E69",
    d: "M21.901 31.748c-2.856-1.072-6.744-2.588-6.744-2.588S14.54 33.911 18 38.215a12.44 12.44 0 0 0 6.59 4.267l-2.689-10.734z",
    opacity: 0.38,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5C298",
    d: "M21.893 17.695l-6.07 9.59c-1.747 3.316-.548 7.428 2.72 9.264 2.612 1.467 4.428 1.93 8.125 2.404 3.08.394 5.339-2.086 6.33-6.003 1.286-5.082 1.026-10.127.735-12.82-.662-6.137-7.426-8.395-11.84-2.435"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1AA80",
    d: "M28.58 35.3c-3.174-1.516-6.996 2.906-11.727-3.397-.882-1.176-.923-3.476-.896-4.828l-.133.209c-1.748 3.317-.55 7.429 2.72 9.265 2.612 1.467 4.427 1.93 8.124 2.404 1.879.24 3.45-.593 4.616-2.165-.62-.055-1.735-1.024-2.704-1.488"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#A399FF",
    d: "M-13.526 49.62c11.606 2.552 21.771 55.137 33.11 72.5 5.237 8.02 61.819-23.832 73.056-7.519 2.187 3.174.832 14.802-2.35 18.327C75.126 149.73 26.71 172.346.224 159.086-21.336 148.292-40.393 96.003-35.052 65c1.357-7.874 5.363-18.932 21.526-15.38"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#614CD4",
    d: "M76.142 124.496c-5.075 7.25-36.252 17.69-44.829 14.5-8.578-3.19-15.93 1.016-24.92 2.03-8.99 1.015-15.951-14.21-15.806-26.391.145-12.18-7.685-25.376-15.516-33.352-6.51-6.63-3.364-24.583-2.117-30.452-5.265 3.058-7.156 9.236-8.006 14.169-5.34 31.003 13.716 83.292 35.276 94.086 26.486 13.26 74.902-9.356 90.067-26.158 2.598-2.88 3.976-11.166 3.201-15.833-6.95 1.363-14.739 3.67-17.35 7.4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5C298",
    d: "M20.702 22.92c.025-.703.156-1.393.327-2.074.327-1.297.512-3.299-1.65-2.837-3.143.67-4.505 7.671-1.435 9.004 2.28.991 2.695-2.322 2.758-4.093"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M25.566 28.26s3.534 1.367 6.864.9c0 0-.362 2.742-3.58 2.741-3.284 0-3.284-3.642-3.284-3.642"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#311E69",
    d: "M31.337 17.829s-3.486-1.59-5.636.222c-2.15 1.813-2.254 2.59-2.687 4.33-.808 3.252-4.106 2.37-4.504.66-.399-1.71-2.25 1.225-2.25 1.225l-1.761 3.17s-1.927-12.373-.87-17.677C14.687 4.455 21.875 6.4 21.875 6.4S23.65.264 32.781.25c11.326-.014 11.416 13.605 4.28 17.17-3.651 1.825-5.724.408-5.724.408"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E1240",
    d: "M37.547 1.291c.6 2.548-.163 5.908-2.905 8.296-3.242 2.824-12.375.708-12.375.708s-2.441 6.578-8.906 5.876c.223 5.39 1.138 11.265 1.138 11.265l1.76-3.17s1.852-2.935 2.25-1.225c.399 1.71 3.696 2.592 4.505-.661.432-1.739.537-2.516 2.687-4.329 2.15-1.812 5.636-.222 5.636-.222s2.073 1.417 5.724-.407c5.938-2.967 6.865-12.89.486-16.13"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPersonWithCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/person_with_circle.865cbd24.svg";
export { ForwardRef as ReactComponent };